import React from 'react';
import ServicePageShell from '../../components/ServicePageShell';
import StatutResidentStatic from './StatutResidentStatic';

export default function StatutResident() {
  return (
    <ServicePageShell
      strapiApiId="annexe-status-resident"
      defaultSectionLabel="Annexes"
      defaultTitle="Statuts de résident"
      StaticFallback={StatutResidentStatic}
    />
  );
}
